(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
(function() {
  // Quantity buttons
  document.querySelectorAll('[data-decrease-qty]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const key = this.getAttribute('data-decrease-qty');
      const input = document.querySelector('[data-quantity-input="' + key + '"]');
      if (!input) return;
      if (parseInt(input.value) <= 1) {
        window.location.href = this.closest('.cart__item').querySelector('.cart__item-remove').href;
      } else {
        input.value = parseInt(input.value) - 1;
      }
    });
  });

  document.querySelectorAll('[data-increase-qty]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const key = this.getAttribute('data-increase-qty');
      const input = document.querySelector('[data-quantity-input="' + key + '"]');
      if (input) {
        input.value = parseInt(input.value) + 1;
        input.closest('form').submit();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-addresses"]) return;
  try {
    
(function() {
  // Toggle add address form
  const toggleAddBtn = document.querySelector('[data-toggle-add-address]');
  const addForm = document.querySelector('[data-add-address-form]');
  const cancelAddBtn = document.querySelector('[data-cancel-add-address]');

  if (toggleAddBtn && addForm) {
    toggleAddBtn.addEventListener('click', function() {
      addForm.style.display = addForm.style.display === 'none' ? 'block' : 'none';
      toggleAddBtn.style.display = addForm.style.display === 'none' ? 'inline-flex' : 'none';
    });
  }

  if (cancelAddBtn && addForm && toggleAddBtn) {
    cancelAddBtn.addEventListener('click', function() {
      addForm.style.display = 'none';
      toggleAddBtn.style.display = 'inline-flex';
    });
  }

  // Toggle edit address forms
  document.querySelectorAll('[data-toggle-edit-address]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const addressId = this.getAttribute('data-toggle-edit-address');
      const editForm = document.querySelector('[data-edit-address-form="' + addressId + '"]');
      if (editForm) {
        editForm.style.display = editForm.style.display === 'none' ? 'block' : 'none';
      }
    });
  });

  document.querySelectorAll('[data-cancel-edit-address]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const addressId = this.getAttribute('data-cancel-edit-address');
      const editForm = document.querySelector('[data-edit-address-form="' + addressId + '"]');
      if (editForm) {
        editForm.style.display = 'none';
      }
    });
  });

  // Delete address
  document.querySelectorAll('[data-delete-address]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const addressId = this.getAttribute('data-delete-address');
      if (confirm('Are you sure you want to delete this address?')) {
        Shopify.postLink('/account/addresses/' + addressId, { parameters: { _method: 'delete' } });
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-login"]) return;
  try {
    
(function() {
  const showRecover = document.querySelector('[data-show-recover]');
  const hideRecover = document.querySelector('[data-hide-recover]');
  const recoverForm = document.querySelector('[data-recover-form]');
  const loginForm = document.querySelector('.customer-login__form:not([data-recover-form] .customer-login__form)');

  if (showRecover && recoverForm) {
    showRecover.addEventListener('click', function(e) {
      e.preventDefault();
      loginForm.style.display = 'none';
      recoverForm.style.display = 'block';
    });
  }

  if (hideRecover && recoverForm) {
    hideRecover.addEventListener('click', function(e) {
      e.preventDefault();
      recoverForm.style.display = 'none';
      loginForm.style.display = 'block';
    });
  }

  // Check URL hash for recover
  if (window.location.hash === '#recover') {
    if (loginForm) loginForm.style.display = 'none';
    if (recoverForm) recoverForm.style.display = 'block';
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    const header   = document.querySelector('[data-header]');
    const toggle   = document.querySelector('[data-menu-toggle]');
    const drawer   = document.querySelector('[data-side-nav]');
    const backdrop = document.querySelector('[data-menu-backdrop]');

    function open() {
      toggle.setAttribute('aria-expanded', 'true');
      drawer.classList.add('is-open');
      backdrop.classList.add('is-visible');
      header.classList.add('menu-open');
      document.body.classList.add('menu-open');
    }

    function close() {
      toggle.setAttribute('aria-expanded', 'false');
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-visible');
      header.classList.remove('menu-open');
      document.body.classList.remove('menu-open');
    }

    if (toggle && drawer) {
      toggle.addEventListener('click', function() {
        this.getAttribute('aria-expanded') === 'true' ? close() : open();
      });

      backdrop.addEventListener('click', close);

      drawer.querySelectorAll('[data-drawer-link]').forEach(function(link) {
        link.addEventListener('click', close);
      });

      // Escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') close();
      });
    }

    // Announcement banner: slide the header bar up in lockstep with the banner as it
    // scrolls out of view, then let it rest against the top — no jump. Only the visible
    // bar (.header__container) is transformed, so the fixed drawer/backdrop are untouched.
    const banner = document.querySelector('[data-announcement-banner]');
    const headerBar = header ? header.querySelector('.header__container') : null;
    if (banner && headerBar) {
      const bannerHeight = banner.offsetHeight;
      let ticking = false;
      const update = function() {
        const offset = Math.min(window.scrollY, bannerHeight);
        headerBar.style.transform = 'translateY(-' + offset + 'px)';
        ticking = false;
      };
      const onScroll = function() {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    }

  })();

  } catch(e) { console.error(e); }
})();
})();
